import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';
import BackButton from '@/components/common/BackButton';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

import CoachActivityLocationForm from './components/coachActivityLocationsPage/CoachActivityLocationForm';

import { useApplication } from '@/data/application';
import { useCoachSelf } from '@/data/coach';
import { useCoachActivity } from '@/data/coachActivity';
import { useCoachActivityLocations } from '@/data/coachActivityLocation';

const CoachActivityLocationsPage = () => {
  const coach = useCoachSelf();
  const params = useParams();
  const coachActivity = useCoachActivity(params.coachActivityId);
  const applicationStructure = useApplication({
    coachActivityId: params.coachActivityId
  });
  const coachActivityLocations = useCoachActivityLocations(
    params.coachActivityId
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (coach.isLoading && !coach.data) {
    return <PageLoading />;
  }
  if (coachActivity.isLoading && !coachActivity.data) {
    return <PageLoading />;
  }
  if (applicationStructure.isLoading && !applicationStructure.data) {
    return <PageLoading />;
  }
  if (coachActivityLocations.isLoading && !coachActivityLocations.data) {
    return <PageLoading />;
  }

  return (
    <Page>
      <BackButton to={`/application/${params.coachActivityId}`} />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Locations</CardTitle>
          <span className="text-muted-foreground">
            Please select a few locations where you would like to operate. These
            can be adjusted later.
          </span>
        </CardHeader>
        <CardContent>
          <CoachActivityLocationForm />
        </CardContent>
      </Card>
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default CoachActivityLocationsPage;
